import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
export const StyledMultiColumnGroup = styled.div.withConfig({
  displayName: "MultiColumnGroup__StyledMultiColumnGroup"
})(["border-color:", ";border-width:1px 0 0;border-style:solid;@media only screen and (min-width:576px){display:table-row;border-color:", ";}", ";"], ({
  theme
}) => theme.color['border-core-subtle'], ({
  theme
}) => theme.color['fill-transparent-default'], ({
  $cssStyles
}) => $cssStyles && $cssStyles);
export const MultiColumnGroup = _ref => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledMultiColumnGroup, Object.assign({}, domProps, {
    $cssStyles: cssStyles,
    children: children
  }));
};
MultiColumnGroup.displayName = 'MultiColumnGroup';